import React from 'react'
import Link from '../Link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import {
  sevenColumnImageOuterContainer,
  sevenColumnImageInnerContainer,
  sevenColumnImageColumnContainer,
  sevenColumnImageHeadingContainer,
  sevenColumnImageColumn,
  sevenColumnImageDark,
  sevenColumnImageImageContainer,
  sevenColumnImageLeft,
  sevenColumnImageRight,
  sevenColumnTextColumn,
  altButtonStyle,
  defaultButtonStyle,
} from './index.module.css'

import { isSvgOrGif } from '../../utils'

const sevenColumnImage = ({
  title,
  subtitle,
  images,
  isDarkTheme,
  hideTitle,
  backgroundColor,
  imageTextPosition,
  ctaUrl,
  ctaText,
  ctaDefaultDisplay,
}) => {
  const defaultBackgroundColor = isDarkTheme ? '#000000' : '#ffffff'
  const image = images.length > 0 ? images[0] : ''
  const imagePositionClass =
    imageTextPosition !== null && imageTextPosition === 'left'
      ? sevenColumnImageLeft
      : sevenColumnImageRight
  return (
    <div
      className={[
        isDarkTheme ? sevenColumnImageDark : '',
        imagePositionClass,
      ].join(' ')}
      style={{
        backgroundColor: backgroundColor
          ? backgroundColor
          : defaultBackgroundColor,
      }}
    >
      <div className={['wrapper', sevenColumnImageOuterContainer].join(' ')}>
        <div
          className={['container', sevenColumnImageInnerContainer].join(' ')}
        >
          <div className={[sevenColumnImageColumnContainer].join(' ')}>
            <div className={sevenColumnImageColumn}>
              {image &&
                (isSvgOrGif(image.file.url) ? (
                  <div className={sevenColumnImageImageContainer}>
                    <img src={image.file.url} alt={image.description} />
                  </div>
                ) : (
                  <div className={sevenColumnImageImageContainer}>
                    <GatsbyImage
                      image={getImage(image.sevenColumnImage)}
                      alt={image.description}
                    />
                  </div>
                ))}
            </div>
            <div className={sevenColumnImageColumn}>
              <div className={sevenColumnTextColumn}>
                {(hideTitle === null || hideTitle === false) && (
                  <div className={sevenColumnImageHeadingContainer}>
                    <h2>{title}</h2>
                  </div>
                )}
                {subtitle && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: subtitle?.childMarkdownRemark?.html,
                    }}
                  />
                )}
                {ctaText && ctaUrl && (
                  <Link
                    className={[
                      ctaDefaultDisplay !== null && !ctaDefaultDisplay
                        ? altButtonStyle
                        : defaultButtonStyle,
                    ].join(' ')}
                    to={ctaUrl}
                  >
                    {ctaText}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default sevenColumnImage
